export enum TICKET_TYPE {
  ETC_TICKETS = 'etc-tickets',
  HIGHWAY_MAINTENANCE_FEE_TICKETS = 'highway-maintenance-fee-tickets',
  COMPULSORY_INSURANCE_PENALTY_TICKETS = 'compulsory-insurance-penalty-tickets',
  HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKETS = 'highway-maintenance-fee-penalty-tickets',
}

export const TICKET_TYPE_VALUES: TICKET_TYPE[] = [
  TICKET_TYPE.ETC_TICKETS,
  TICKET_TYPE.COMPULSORY_INSURANCE_PENALTY_TICKETS,
  TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKETS,
  TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_TICKETS,
];

export enum TICKET_MODE {
  PENDING = 'pending',
  HISTORY = 'history',
}

export const TICKET_TYPE_CONFIG: Record<
  `${TICKET_TYPE}`,
  {
    key: TICKET_TYPE;
    name: string;
    queryPlatform: string;
    getQueryPlatformLink: (...args: Array<unknown>) => string | undefined;
  }
> = {
  [TICKET_TYPE.ETC_TICKETS]: {
    key: TICKET_TYPE.ETC_TICKETS,
    name: 'ETC 通行費',
    queryPlatform: '遠通電收',
    getQueryPlatformLink: () => `https://www.fetc.net.tw/`,
  },
  [TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_TICKETS]: {
    key: TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_TICKETS,
    name: '公路養管費',
    queryPlatform: '街口支付',
    getQueryPlatformLink: () => undefined,
  },
  [TICKET_TYPE.COMPULSORY_INSURANCE_PENALTY_TICKETS]: {
    key: TICKET_TYPE.COMPULSORY_INSURANCE_PENALTY_TICKETS,
    name: '違反強制險罰鍰',
    queryPlatform: '街口支付',
    getQueryPlatformLink: () => undefined,
  },
  [TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKETS]: {
    key: TICKET_TYPE.HIGHWAY_MAINTENANCE_FEE_PENALTY_TICKETS,
    name: '公路養管費罰鍰',
    queryPlatform: '街口支付',
    getQueryPlatformLink: () => undefined,
  },
};

export const DEFAULT_CHARGE_FAIL_RETRY_DAYS = 2;
